import { ReactNode, useCallback, useEffect, useMemo } from 'react';
import classNames from 'classnames';

import { ISSUE_COLLECTOR_URL } from 'constants-module';
import { environment } from 'environments';

import styles from './Navigation.module.scss';
import { useAppSelector } from '../../../../hooks';
import { getLanguage, getUser } from '../../../../store';
import { Language } from '../../../../enums';

declare global {
  interface Window {
    ATL_JQ_PAGE_PROPS: any;
    showCollectorDialog: any;
  }
}

export type NavigationProps = {
  children?: ReactNode;
  className?: string;
};

export const Navigation = ({ children, className }: NavigationProps) => {
  const currentUser = useAppSelector(getUser);
  const selectedLanguage = useAppSelector(getLanguage);

  const fullName = useMemo(() => {
    if (!currentUser) {
      return '';
    }

    return selectedLanguage === Language.RU
      ? `${currentUser.lastName} ${currentUser.firstName}`
      : `${currentUser.lastNameEn} ${currentUser.firstNameEn}`;
  }, [currentUser, selectedLanguage]);

  const initializeIssueCollector = useCallback(() => {
    const issueCollectorScript = document.createElement('script');
    const issueCollectorPropsScript = document.createElement('script');

    issueCollectorScript.type = 'text/javascript';
    issueCollectorScript.src = ISSUE_COLLECTOR_URL;
    issueCollectorScript.async = true;

    issueCollectorPropsScript.type = 'text/javascript';
    issueCollectorPropsScript.async = true;
    issueCollectorPropsScript.innerHTML = `
      window.ATL_JQ_PAGE_PROPS = {
        triggerFunction: showCollectorDialog => window.showCollectorDialog = showCollectorDialog,
        fieldValues: {
          recordWebInfo: '1',
          recordWebInfoConsent: ['1'],
          fullname: '${fullName}',
          email: '${currentUser?.email || ''}',
        },
        environment: {
          'Build-Version': 'v${environment.appVersion}',
        },
      };
    `;

    document.body.appendChild(issueCollectorScript);
    document.body.appendChild(issueCollectorPropsScript);
  }, [currentUser?.email, fullName]);

  useEffect(() => {
    // TODO: Need to fix Issue Collector (url)
    initializeIssueCollector();
  }, [initializeIssueCollector]);

  return <aside className={classNames(styles.navigation, className)}>{children}</aside>;
};
